import type {
  GetCuratedReviewsRequest,
  GetMyReviewsRequest,
  GetProductReviewsRequest,
  GetReviewCreditAmountsRequest,
  GetReviewCreditSummaryRequest,
  ReviewStatisticsRequest,
} from './types';

export const REVIEW_QUERY_KEYS = {
  default: () => ['review'] as const,
  productScope: (productId: number) => [...REVIEW_QUERY_KEYS.default(), 'product', productId] as const,
  myScope: () => [...REVIEW_QUERY_KEYS.default(), 'me'] as const,
  getProductReviews: (productId: number, params?: Omit<GetProductReviewsRequest, 'productId'>) =>
    [...REVIEW_QUERY_KEYS.productScope(productId), params] as const,
  getAIProductReviews: (productId: number, params?: Omit<GetProductReviewsRequest, 'productId'>) =>
    [...REVIEW_QUERY_KEYS.productScope(productId), 'ai', params] as const,
  getCuratedReviews: (params?: GetCuratedReviewsRequest) =>
    [...REVIEW_QUERY_KEYS.default(), 'curated', params] as const,
  getMyReviews: (params?: GetMyReviewsRequest) => [...REVIEW_QUERY_KEYS.myScope(), params] as const,
  getReviewCreditAmounts: (params?: GetReviewCreditAmountsRequest) =>
    [...REVIEW_QUERY_KEYS.default(), 'creditAmounts', params] as const,
  creditEligibilityScope: () => [...REVIEW_QUERY_KEYS.default(), 'creditEligibility'] as const,
  creditSummaryScope: () => [...REVIEW_QUERY_KEYS.default(), 'creditSummary'] as const,
  getReviewCreditEligibility: (productId: number) =>
    [...REVIEW_QUERY_KEYS.creditEligibilityScope(), productId] as const,
  getReviewCreditSummary: (params?: GetReviewCreditSummaryRequest) =>
    [...REVIEW_QUERY_KEYS.creditSummaryScope(), params] as const,
  statisticsScope: () => [...REVIEW_QUERY_KEYS.default(), 'statistics'] as const,
  getReviewStatistics: (params: ReviewStatisticsRequest) => [...REVIEW_QUERY_KEYS.statisticsScope(), params] as const,
};

export const REVIEW_MUTATION_KEYS = {
  createReview: () => ['review', 'create'] as const,
  updateReview: () => ['review', 'update'] as const,
};
